'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);

var _components = require('../../components');

var _foreignPropertyPageProperties = require('../../redux/modules/foreignPropertyPageProperties');
var _propertyDetails = require('../../redux/modules/propertyDetails');


var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../../constants');






var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _favoriteProperties = require('../../redux/modules/favoriteProperties');
var _Slider = require('../../components/HomePagePropertiesCarousel/components/Slider');
var _helpers = require('./helpers');

var _ForeignPagePropertiesContainer = require('./ForeignPagePropertiesContainer.scss');var styles = _interopRequireWildcard(_ForeignPagePropertiesContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
var limit = 20;var ForeignPagePropertiesContainer = function (_Component) {_inherits(ForeignPagePropertiesContainer, _Component);
  function ForeignPagePropertiesContainer(props) {_classCallCheck(this, ForeignPagePropertiesContainer);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.






































    getOptionByType = function (type) {
      if (_constants.optionTypes[type]) {
        return type;
      }

      return _constants.optionTypes.buy;
    };_this.

    getLocation = function () {return _this.props.isProjects ? 'project_details' : 'home_details';};_this.

    loadPropertiesData = function (type) {var additionalFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var option = _this.props.isProjects ? undefined : _this.getOptionByType(type);
      var requestType = _this.props.isProjects ? 'projects' : 'properties';
      var params = Object.assign({
        option: option,
        country: (type || '').replace(/-/g, ' '),
        $sort: '-created_at' },
      _this.query,
      additionalFilters);


      _this.props.loadProperties({ requestType: requestType, params: params, carouselType: type });
    };_this.

    openDetailsHandler = function (evt, propertyId) {var _evt$target =
      evt.target,classList = _evt$target.classList,parentElement = _evt$target.parentElement;

      var isFavoriteIcon = classList.contains('favoriteToggler');
      var isArrowIcon = classList.contains(_Slider.homeCarouselArrowClassName) ||
      parentElement.classList.contains(_Slider.homeCarouselArrowClassName);

      if (isArrowIcon || isFavoriteIcon) {
        return;
      }

      _this.openDetails(evt, propertyId);
    };_this.

    openDetails = function (evt, propertyId) {
      var location = _this.getLocation();
      var entityType = _this.props.isProjects ? _constants.ENTITY_TYPES.PROJECT : _constants.ENTITY_TYPES.PROPERTY;
      var route = (0, _appendLocale2.default)(
      _this.props.locale, '/' +
      location + '/' + propertyId);


      if (evt.ctrlKey || evt.metaKey) {
        window.open(route);
      } else if (_this.props.isMobile) {
        _reactRouter.browserHistory.push(route);
      } else {
        var modalRoute = '/' + _constants.ROUTES_PATHS.FOREIGN;
        _reactRouter.browserHistory.push({
          pathname: (0, _appendLocale2.default)(_this.props.locale, modalRoute),
          query: { id: entityType + '_' + propertyId } });

        _this.props.openDetailsPopup({ propertyId: propertyId, entityType: entityType });
      }
    };_this.

    changeActiveIdx = function (index) {return _this.props.setSliderState(Object.assign({
        carouselType: _this.props.carouselType },
      _this.props.sliderState, {
        index: index }));};_this.


    toggleFavorite = function (property) {var isProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;return (
        _this.props.toggleFavorite({ property: property, token: _this.props.userToken, isProject: isProject }));};_this.

    handleClickLink = function (type) {
      var pathname = (0, _appendLocale2.default)(
      _this.props.locale, '/' +
      _constants.ROUTES_PATHS.FOREIGN + '/' + _this.props.carouselType + '/' + _constants.ROUTES_ADDITIONAL.FOREIGN_SEARCH);

      var query = { type: [type] };

      _reactRouter.browserHistory.push({ pathname: pathname, query: query });
    };_this.

    renderPropertiesCarousel = function () {return (
        _react2.default.createElement(_components.ForeignPropertiesCarousel, {
          locale: _this.props.locale,
          openDetailsPopup: _this.props.openDetailsPopup,
          translate: _this.props.translate,
          properties: _this.props.isFavorites ? _this.props.favoritesData : _this.props.propertiesData,
          handleClick: _this.openDetailsHandler,
          isMobile: _this.props.isMobile,
          isRtl: _this.props.isRtl,
          toggleFavorite: _this.toggleFavorite,
          favoriteProperties: _this.props.favoriteProperties,
          activeIdx: (0, _get2.default)(_this.props, 'sliderState.index', 0),
          changeActiveIdx: _this.changeActiveIdx,
          isProjects: _this.props.isProjects,
          screenWidth: _this.props.screenWidth }));};_this.



    renderAdditionalFilters = function () {
      if (!_this.props.withPropertyTypesFilter) {
        return null;
      }
      return (
        _react2.default.createElement('div', { className: styles.chipsWrapper },
          _react2.default.createElement(_components.HomePagePropertiesChips, {
            name: 'home-page-' + _this.props.carouselType + '-carousel-chips',
            values: _this.state.propertyTypes,
            onChange: _this.handleClickLink,
            className: 'solid' })));



    };_this.query = { $skip: 0, $limit: limit };_this.state = { propertyTypes: props.withPropertyTypesFilter ? (0, _helpers.getPropertyTypesValues)(props.translate) : [] };return _this;}ForeignPagePropertiesContainer.prototype.componentDidMount = function componentDidMount() {if (!this.props.isFavorites && !this.props.propertiesIsLoading) {this.loadPropertiesData(this.props.carouselType, Object.assign({}, this.props.additionalFilters, (0, _omit2.default)(this.props.sliderState, ['index'])));}};ForeignPagePropertiesContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.locale !== this.props.locale) {var stateModifier = {};if (this.props.withPropertyTypesFilter) {stateModifier.propertyTypes = (0, _helpers.getPropertyTypesValues)(nextProps.translate);}this.setState(Object.assign({}, stateModifier));}if (!nextProps.isDetailsModalOpen && this.props.isDetailsModalOpen) {var _browserHistory$getCu = _reactRouter.browserHistory.getCurrentLocation(),_browserHistory$getCu2 = _browserHistory$getCu.pathname,pathname = _browserHistory$getCu2 === undefined ? '/' + _constants.ROUTES_PATHS.FOREIGN : _browserHistory$getCu2;_reactRouter.browserHistory.push({ pathname: pathname, query: {} });}};ForeignPagePropertiesContainer.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        this.renderPropertiesCarousel(),
        this.renderAdditionalFilters()));


  };return ForeignPagePropertiesContainer;}(_react.Component);


ForeignPagePropertiesContainer.propTypes = {
  carouselType: _propTypes2.default.string,
  withCitiesFilter: _propTypes2.default.bool,
  isFavorites: _propTypes2.default.bool,
  isProjects: _propTypes2.default.bool,
  withPropertyTypesFilter: _propTypes2.default.bool,
  additionalFilters: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  propertiesIsLoading: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  propertiesData: _propTypes2.default.array,
  hasNextPage: _propTypes2.default.bool,
  favoritesData: _propTypes2.default.array,
  loadProperties: _propTypes2.default.func,
  favoriteProperties: _propTypes2.default.array,
  toggleFavorite: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  setSliderState: _propTypes2.default.func,
  sliderState: _propTypes2.default.object,
  userToken: _propTypes2.default.string,
  isDetailsModalOpen: _propTypes2.default.bool,
  screenWidth: _propTypes2.default.number };


var mapStateToProps = function mapStateToProps(state, props) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    screenWidth: state.windowDimentions.width,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    propertiesData: state.foreignPropertyPageProperties[props.carouselType] || [],
    propertiesIsLoading: state.foreignPropertyPageProperties.loading,
    hasNextPage: (0, _get2.default)(state, 'foreignPropertyPageProperties[' + props.carouselType + 'Meta].hasNextPage'),
    sliderState: state.foreignPropertyPageProperties[props.carouselType + 'SliderState'],
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    favoritesData: props.isFavorites ? state.favoriteProperties.favoritesData || [] : null,
    favoriteProperties: state.favoriteProperties.favoriteIDs || [],
    isDetailsModalOpen: state.propertyDetails.isDetailsModalOpen };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  loadProperties: _foreignPropertyPageProperties.loadProperties,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  setSliderState: _foreignPropertyPageProperties.setSliderState,
  openDetailsPopup: _propertyDetails.openDetailsPopup })(
ForeignPagePropertiesContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignPagePropertiesContainer/ForeignPagePropertiesContainer.js
// module id = 2973
// module chunks = 0